<script setup lang="ts">
const error = useError();

const handleError = () => {
    // log the full error to the console
    console.error(error.value);
};

// After load, if there is an error and the enviuronment is not prod, console.error
onMounted(() => {
    if (error.value && import.meta.env.MODE !== "production") {
        handleError();
    }
});
</script>

<template>
    <div class="flex justify-center items-center px-4 py-12 min-h-screen bg-gray-50 dark:bg-gray-800 sm:px-6 lg:px-8">
        <div class="w-full max-w-md text-center">
            <h1 class="text-9xl font-bold text-primary-600 dark:text-coral-600">{{ error?.statusCode }}</h1>
            <h2 class="mt-4 text-3xl font-bold text-gray-900 dark:text-gray-100">{{ error?.message }}</h2>
            <p v-if="error?.statusCode === 404" class="mt-2 text-lg text-gray-600 dark:text-coral-400">
                Sorry, we couldn't find the page you're looking for.
            </p>
            <div class="mt-6">
                <NuxtLink
                    to="/dashboard"
                    class="inline-flex items-center px-4 py-2 font-bold text-center text-white rounded-full border border-transparent bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:bg-coral-600 dark:hover:bg-coral-700">
                    Back to Dashboard
                </NuxtLink>
            </div>
        </div>
    </div>
</template>
